import { useCallback } from "react";

import { Action, Marker, MarkerType, StencilType } from "../../types";
import { createNewBall, frameStencilController } from "../../utils";
import { UpdateFrameStencils } from "./use-update-frame-stencils";

export interface AddStencilsProps {
  stencils: (Action | Marker)[];
}
export type AddStencilsFunc = (props: AddStencilsProps) => void;
export const useAddStencils = (updateFrameStencils: UpdateFrameStencils): AddStencilsFunc => {
  return useCallback(
    ({ stencils }) => {
      const stencilsWithBalls: (Marker | Action)[] = stencils.flatMap((stencil) => {
        const ballStencil =
          stencil.stencilType === StencilType.MARKER && stencil.markerType === MarkerType.PLAYER && stencil.possession
            ? createNewBall({ pos: stencil.pos, associatedPlayer: stencil.id })
            : null;
        return [stencil, ...(ballStencil ? [ballStencil] : [])];
      });

      // frame stencils set state
      updateFrameStencils((prevState) =>
        stencilsWithBalls.reduce(
          (acc, stencil) => frameStencilController({ operation: "ADD", stencils: acc, stencil }),
          prevState
        )
      );
    },
    [updateFrameStencils]
  );
};
